
// when this is loaded into the browser, 
// just use the defaults...

module.exports = function (name, defaults) {
  return defaults
}



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/rc/browser.js
// module id = 769
// module chunks = 0